import { c as _c } from "react/compiler-runtime";
import TextareaAutosize from 'react-textarea-autosize';
import style from './Textarea.module.scss';
function Textarea(props) {
  const $ = _c(12);
  let t0;
  if ($[0] !== props.placeholder || $[1] !== props.register) {
    t0 = <TextareaAutosize placeholder={props.placeholder} className={style.textarea} {...props.register} maxRows={10} />;
    $[0] = props.placeholder;
    $[1] = props.register;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.label) {
    t1 = <label className={style.textareaLabel}>{props.label}</label>;
    $[3] = props.label;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props.errorLabel || $[6] !== props.errors) {
    t2 = Boolean(props.errors) && <span className={style.textareaError}>{props.errors && props.errorLabel}</span>;
    $[5] = props.errorLabel;
    $[6] = props.errors;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t3 = <>{t0}{t1}{t2}</>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export default Textarea;